import { FCX, ID } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useMemo } from "react";
import { useGetMacStage } from "@core/CommonDataContext";
import { MAC_STAGE_COLORS, MacStage } from "@models/MacStage";

type Modifiers = 'small' | 'medium';

const MacStageLabel: FCX<{
    macStageId: ID;
    modifiers?: Modifiers[];
}> = ({
    macStageId,
    modifiers = [],
    className,
    children,
    testId,
    ...props
}) => {
    const option = useGetMacStage()(macStageId);

    const macStage = useMemo(
        () => {
			const macStageColors = MAC_STAGE_COLORS[option?.id as MacStage]

            if (option) {
                return {
                    ...option,
                    bgColor: macStageColors.bgColor,
                    color: macStageColors.color,
                }
            }
        },
        [option]
    );

    if (!macStage) {
        return null;
    }

    return (
        <div
            className={cn(
                'MacStageLabel',
                className,
                ...modifiers.map((m) => `is-${m}`),
            )}
            data-testid={testId}
            {...props}
            style={{
                backgroundColor: macStage.bgColor,
	            color: macStage.color,
            }}
        >
            {macStage.name}
        </div>
    );
};

export default MacStageLabel;